import logo from './logo.svg';
import Navbar from './pages/Navbar/Navbar';
import './App.css';
import AppRoute from './AppRoute/AppRoute'
import { ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
function App() {
  return (
    <>
      <ToastContainer autoClose={5000} />
      <AppRoute />
    </>
  );
}

export default App;
